<template>
	<div class="latest-news-page">
		<!-- 页面头部（导航栏 + 面包屑） -->
		<newsPageHeader />

		<!-- 资讯列表主体 -->
		<div class="news-list-section animate__animated animate__fadeInUp">
			<div class="news-list-inner">
				
				<div class="zwBox" v-if="!resultList.length">
					<el-image :src="require('@/static/zw.svg')"></el-image>
					<p>{{$t('newsList.t1')}}</p>
				</div>
				
				<!-- 资讯卡片 -->
				<div
				v-for="(item, index) in resultList"
				:key="index"
				class="news-card"
				:class="{ 'is-hover': 0 }"
				@mouseenter="handleCardHover(index, true)"
				@mouseleave="handleCardHover(index, false)"
				@click="goToDetail(item)">
					<!-- 左侧配图 -->
					<div class="card-img-wrap">
						<el-image class="card-img" :src="item.picture" fit="cover"></el-image>
					</div>
					<div class="rMsg">
						<div class="dateBox">
							<!-- 右上角箭头 -->
							<el-image class="card-arrow" :src="require('@/static/CodeBuddyAssets/31159_1817/18.svg')"></el-image>
							<!-- 日期 -->
							<div class="card-date">
								<span class="date-day">{{ item.day }}</span>
								<span class="date-month">{{ item.month }}</span>
							</div>
						</div>
						<div class="txtBox">
							<!-- 标题 -->
							<h3 class="card-title">{{ item.title }}</h3>
							<!-- 描述 -->
							<p class="card-desc">{{ item.descriptions }}</p>
						</div>
					</div>
				</div>
			</div>
		</div>

		<!-- Element-UI 分页器 -->
		<div v-if="resultList.length" class="pagination-wrap animate__animated animate__fadeInUp">
			<el-pagination
				background
				layout="prev, pager, next, jumper"
				:total="total"
				:page-size="pageSize"
				:current-page.sync="currentPage"
				@current-change="handleCurrentChange">
			</el-pagination>
		</div>
		
	</div>
</template>

<script>
import {
	articlelist,
} from "/src/api/api.js"
import newsPageHeader from '@/components/newsPageHeader.vue'
export default {
	name: 'LatestNews',
	components: {
		newsPageHeader
	},
	data() {
		return {
			currentPage: 1,
			pageSize: 10,
			total: 125,
			resultList: ''
		}
	},
	mounted() {
		this.pageList()
	},
	methods: {
		async pageList(){
			var res;
			res = await articlelist({
				pageNum: this.currentPage,
				pageSize: this.pageSize,
				orderByColumn: 'id',
				isAsc: 'desc',
				categoryId:3,
			});
			if(res.code==200){
				res.rows.forEach((item)=>{
					const datePart = item.createTime.split(' ')[0]; // '2026-06-09'
					const [year, month, day] = datePart.split('-');
					item.day = day
					item.month = `${year}/${month}`
				})
				this.total = res.total
				this.resultList = res.rows
			}else{this.Tips(res.msg,'error')}
		},
		// 跳转至资讯详情页
		goToDetail(item){
			this.link('/newsDetail',{id:item.id})
		},
		handleCardHover(index, isEnter) {
			this.$set(this.newsList[index], 'hoverStyle', isEnter)
		},
		handleCurrentChange(page) {
			this.currentPage = page
			this.pageList()
		}
	}
}
</script>

<style lang="scss" scoped>
/* ===== 页面容器 ===== */
.latest-news-page {
	width: 100%;
	min-height: 100vh;
	background: #fff;
	position: relative;
}

/* ===== 资讯列表区域 ===== */
.news-list-section {
	padding: 0.50rem 0 0.60rem;
	padding-top: 40px;
}
.news-list-inner {
	width: 13.36rem;
	margin: 0 auto;
	display: flex;
	flex-direction: column;
}

/* ===== 资讯卡片 ===== */
.news-card {
	position: relative;
	width: 13.36rem;
	height: 2.26rem;
	background: #F8F8F8;
	border: 0.01rem solid rgba(255, 255, 255, 1);
	border-radius: 0.04rem;
	display: flex;
	// align-items: center;
	cursor: pointer;
	transition: background-color 0.35s cubic-bezier(0.4, 0, 0.2, 1),
	box-shadow 0.35s cubic-bezier(0.4, 0, 0.2, 1);
	overflow: hidden;
	margin-bottom: 24px;
	&:hover,
	&.is-hover {
		background: #0096FF;
		box-shadow: 0 0.10rem 0.30rem rgba(0, 150, 255, 0.20);
		.card-date .date-day,
		.card-date .date-month {
			color: #ffffff;
		}
		.card-title {
			color: #ffffff;
		}
		.card-desc {
			color: rgba(255, 255, 255, 0.90);
		}
	}
}

/* 左侧配图 */
.card-img-wrap {
	width: 2.95rem;
	height: 1.70rem;
	margin-left: 0.32rem;
	margin-top: 0.28rem;
	margin-bottom: 0.28rem;
	flex-shrink: 0;
	border-radius: 0.04rem;
	overflow: hidden;
	.card-img {
		width: 100%;
		height: 100%;
		object-fit: cover;
	}
}
.rMsg{
	width: calc(100% - 3.27rem);
	height: 1.70rem;
	position: relative;
	padding: 32px;
	padding-top: 0;
	.txtBox{
		padding-top: 50px;
	}
}
/* 日期 */
.dateBox{
	margin-bottom: 14px;
	align-items: flex-start;
	position: absolute;
	top: 0px;
	.card-arrow {
		margin: auto;
		display: block;
		height: 0.02rem;
		z-index: 2;
		width: 100%;
		margin-bottom: 36px;
	}
	.card-date {
		height: 0.50rem;
		display: flex;
		flex-direction: column;
		z-index: 2;
		.date-day {
			font-size: 0.28rem;
			font-family: 'MiSans', 'PingFang SC', sans-serif;
			font-weight: 600;
			color: #0096FF;
			line-height: 1;
			margin-left: 0.14rem;
			transition: color 0.35s;
		}
		.date-month {
			font-size: 0.14rem;
			font-family: 'MiSans', 'PingFang SC', sans-serif;
			font-weight: 500;
			color: #0096FF;
			line-height: 1;
			margin-top: 0.06rem;
			transition: color 0.35s;
		}
	}

}
/* 标题 */
.card-title {
	font-size: 0.24rem;
	font-family: 'PingFang SC', sans-serif;
	font-weight: 500;
	color: #333333;
	line-height: 1.35;
	overflow: hidden;
	text-overflow: ellipsis;
	white-space: nowrap;
	transition: color 0.35s;
	z-index: 2;
	padding-left: 90px;
	padding-bottom: 22px;
}
/* 描述 */
.card-desc {
	font-size: 0.15rem;
	font-family: 'PingFang SC', sans-serif;
	font-weight: 400;
	color: #9C9C9C;
	line-height: 1.6;
	display: -webkit-box;
	-webkit-line-clamp: 3;
	-webkit-box-orient: vertical;
	overflow: hidden;
	transition: color 0.35s;
	z-index: 2;
}



/* 减少动态偏好：禁用过渡动画 */
@media (prefers-reduced-motion: reduce) {
	.news-card,
	.card-date .date-day,
	.card-date .date-month,
	.card-title,
	.card-desc {
		transition: none !important;
	}
}

/* ===== Element-UI 分页器样式 ===== */
::v-deep .el-pagination.is-background .el-pager li{
	background: transparent;
}
::v-deep .el-pagination.is-background .btn-prev{
	background: transparent;
}
::v-deep .el-pagination.is-background .btn-next{
	background: transparent;
}
.pagination-wrap {
	width: 13.36rem;
	margin: 0 auto;
	padding-bottom: 0.60rem;
	display: flex;
	justify-content: center;
	::v-deep .el-pagination__editor {
		margin-right: 12px;
	}
	::v-deep .el-pagination {
		font-weight: 400;
		.el-pager li {
			min-width: 0.32rem;
			height: 0.32rem;
			line-height: 0.32rem;
			font-size: 0.14rem;
			border-radius: 0.04rem;
			margin: 0 0.02rem;
			color: #333;
			&.active {
				background: #0096FF;
				color: #fff;
				border-color: #0096FF;
			}
			&:hover {
				color: #0096FF;
			}
		}
		.el-pagination__total {
			font-size: 0.14rem;
			color: #999;
			margin-right: 0.12rem;
		}
		.btn-prev, .btn-next {
			min-width: 0.32rem;
			height: 0.32rem;
			line-height: 0.32rem;
			font-size: 0.14rem;
			border-radius: 0.04rem;
			&:hover { color: #0096FF; }
		}
		.el-pagination__jump {
			font-size: 0.14rem;
			color: #999;
			margin-left: 0.12rem;
			.el-input__inner {
				width: 0.50rem;
				height: 0.32rem;
				line-height: 0.32rem;
				font-size: 0.14rem;
				border-radius: 0.04rem;
				&:focus { border-color: #0096FF; }
			}
		}
	}
}
</style>
